/* gon */
import { get } from './service'

const fileFormatsEndpoint = gon.get_file_formats_url

export const getFileFormats = () => get(fileFormatsEndpoint)
